module.exports = __webpack_public_path__ + "static/hchoneygummies-5e72461523c4a9aaffe5773d6dc1b2be.jpg";